import api from './api'

const fileTypeService = {
  // Get all file types
  async getFileTypes(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await api.get('/admin/file-types', { params })
      return response
    } catch (error) {
      console.error('Error fetching file types:', error)
      throw error
    }
  },

  // Create new file type
  async createFileType(fileTypeData) {
    try {
      const response = await api.post('/admin/file-types', fileTypeData)
      return response
    } catch (error) {
      console.error('Error creating file type:', error)
      throw error
    }
  },

  // Update file type
  async updateFileType(id, fileTypeData) {
    try {
      const response = await api.put(`/admin/file-types/${id}`, fileTypeData)
      return response
    } catch (error) {
      console.error('Error updating file type:', error)
      throw error
    }
  },

  // Delete file type
  async deleteFileType(id) {
    try {
      const response = await api.delete(`/admin/file-types/${id}`)
      return response
    } catch (error) {
      console.error('Error deleting file type:', error)
      throw error
    }
  }
}

export default fileTypeService 